import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { AuthenticationResponseModelData } from '../models/auth.model';

const API_BASE_URL = environment.stsUrl;
const OKTA_AUTH_URL = `${environment.apiUrl}api/TokenAuth/ExchangeExternal`;

@Injectable({
  providedIn: 'root'
})
export class StsHttpService {
  private readonly customHttpClient: HttpClient;
  constructor(private readonly handler: HttpBackend) {
    this.customHttpClient = new HttpClient(handler);
  }

  //public methods
  public callSts(azureToken: string, partnerId: number): Observable<AuthenticationResponseModelData> {
    const postParams = new HttpParams({
      fromObject: {
        grant_type: 'urn:ietf:params:oauth:grant-type:token-exchange',
        audience: 'Stealth',
        scope: 'StealthApis',
        subject_token: azureToken,
        subject_token_type: 'urn:ietf:params:oauth:token-type:id_token',
        actor_token_type: 'urn:ietf:params:oauth:token-type:id_token',
        partner_id: partnerId
      }
    });

    const paramString = postParams.toString();
    const postOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    };

    const httpResult = this.customHttpClient.post<AuthenticationResponseModelData>(API_BASE_URL, paramString, postOptions);
    return httpResult;
  }

  // Okta → Gateway
  public callOAuth(oktaToken: string, partnerId: number): Observable<AuthenticationResponseModelData> {

    const body = {
      grantType: 'urn:ietf:params:oauth:grant-type:token-exchange',
      audience: 'Stealth',
      scope: 'StealthApis',
      subjectToken: oktaToken,
      subjectTokenType: 'urn:ietf:params:oauth:token-type:id_token',
      actorTokenType: 'urn:ietf:params:oauth:token-type:id_token',
      partnerId: partnerId
    };

    return this.customHttpClient.post<AuthenticationResponseModelData>(
      OKTA_AUTH_URL,
      body
    );
  }
}
